module.exports = __webpack_public_path__ + "static/img/brees-2009-slide-5.2e39122.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2009-slide-5.jpg
// module id = NpGp
// module chunks = 1